<template>
  <div class="workOrderBox">
    <div class="workOrderContentBox">
      <div class="workOrderTop line_bottom">
        <div class="workOrderId">工单ID:{{format.workOrderId}}</div>
        <div class="enterpriseName">
          <span >企业名称：</span>
          <p>{{format.enterpriseName}}</p>
        </div>
        <div class="workOrderBages">
          <div class="locationBage line_border_btn_blue">{{format.regionCode}}</div>
          <div class="industryBage line_border_btn">{{format.industryCategory}}</div>
        </div>
        <!-- 进度线 -->
        <div class="lineBox" v-show="format.flowStatus > '1'">
          <div class="progressLineBox">
            <div class="progressLineBoxItem" v-for="(item, index) in progressLineList" :key="index">
              <div
                class="progressLinePoint"
                :style="{backgroundColor: item.isOver?'#36B374':'#D7F0E3', color: item.isOver?'#333':'#999'}"
              >
                <span class="progressLineText">{{item.text}}</span>
              </div>
              <div
                class="progressLine"
                v-show="index !== 0"
                :style="{backgroundColor: item.isOver?'#36B374':'#D7F0E3'}"
              ></div>
            </div>
          </div>
        </div>
      </div>

      <div class="navBox">
        <!-- 选项nav -->
        <div class="mainContentBox">
          <div class="dataListNav">
            <div
              class="dataListNavItem"
              v-for="(item, index) in dataListNavLists"
              :key="index"
              v-show="item.isShow"
              :class="{'active': isDlNavItem === index}"
              @click="handleDlNavItemActive(index)"
            >{{item.name}}</div>
          </div>
        </div>
        <!-- 评分详细list -->
        <div class="scoreDetailBox" v-show="isDlNavItem === 0">
          <div class="scoreDetailTop">
            <div class="noScore">
              <p class="scoreDetailTop_p" style="color:#ccc" v-if="currentTime=='未开始评分' || currentTime == '无法评分'">{{currentTime}}</p>
              <p class="scoreDetailTop_p" style="color:#36b374" v-else>{{currentTime.replace("分","")}}<span class="unitv">/分</span></p>
              <p v-if="currentTime" class="scoreDetailTop_score">满分10分</p>
            </div>
          </div>
          <div class="scoreDetailListBox">
            <div class="scoreDetailListTitle">
              <div class="title_type">类别</div>
              <div class="title_scoreTarget">评级项目</div>
              <div class="title_scoreResult">评价结果</div>
            </div>
            <!-- 安全list -->
            <div class="safeScoreListBox" v-for="(item, index) in workOrder" :key="index">
              <div class="safeType" ref="index">
                <div class="son">
                  <h4>{{item.groupName}}</h4>
                  <p>满分{{item.normalGroupScore}}分</p>
                </div>
              </div>
              <div class="safeScoreBox" v-for="(e, index) in item.detailList1" :key="index">
                <div class="safeScoreList">
                  <div class="safeScoreListItem">
                    <div class="scoreTarget">{{e.normalItem}}</div>
                    <div class="scoreResult" v-if="e.ratingType" @click="goScoreResult(e)">
                      <div class="targetNoScore" :class="{badness:e.ratingType=='差'}">{{e.ratingType}}</div>
                      <!-- <div class="targetScore"> -->
                      <img class="targetScore" src="../../../../assets/image/ic_jt_ck@2x.png" alt=""/>
                      <!-- </div> -->
                    </div>
                    <div class="scoreResult" v-else>
                      <div class="targetNoScore">暂无</div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="savfdataListBtn"
                v-if="item.detailList && item.detailList.length > 3"
                @click="openBottom(item)"
              >
                <img src="../../../../assets/image/ic_xl@2x.png" v-show="item.scrollFlag"  style="transform: rotate(180deg);"/>
                <img src="../../../../assets/image/ic_xl@2x.png" v-show="!item.scrollFlag" />
              </div>
            </div>
          </div>
        </div>
        <!-- 工单信息list -->
        <div class="workOrderDetaliList" v-show="isDlNavItem === 1">
          <div class="workOrderDetaliItem">
            <div class="workOrderDetaliTitle">评分结果:</div>
            <div class="workOrderDetaliContent"
                :style="{'color': (format.scoreResult === null || format.scoreResult === '')?'#666666':'#333'}"
            >{{(format.scoreResult === null || format.scoreResult === '')?'任务待审核，评分未开始':format.scoreResult}}</div>
          </div>
          <div class="workOrderDetaliItem">
            <div class="workOrderDetaliTitle">评分耗时:</div>
            <div class="workOrderDetaliContent"
                :style="{'color': (format.datePoor === null || format.datePoor === '')?'#666666':'#333'}"
            >{{(format.datePoor === null || format.datePoor === '')?'任务待审核，评分未开始':format.datePoor}}</div>
          </div>
          <div class="workOrderDetaliItem">
            <div class="workOrderDetaliTitle">评分专员:</div>
            <div class="workOrderDetaliContent"
                :style="{'color': (format.employeeName === null || format.employeeName === '')?'#666666':'#333'}"
            >{{(format.employeeName === null || format.employeeName === '')?'任务待审核，评分未开始':format.employeeName}}</div>
          </div>
          <div class="workOrderDetaliItem">
            <div class="workOrderDetaliTitle">目标完成日期:</div>
            <div class="workOrderDetaliContent" v-if='format.taskEndTime'>{{format.taskEndTime| filtTime}}</div>
            <div class="workOrderDetaliContent" v-else style="color:#666666">暂无</div>
          </div>
          <div class="workOrderDetaliItem">
            <div class="workOrderDetaliTitle">所属任务:</div>
            <div class="workOrderDetaliContent" @click="toPageDetail(format)">{{format.taskName}}</div>
          </div>
        </div>
        <!-- 操作记录列表 -->
        <div
          class="operationRecordListBox"
          v-if='format.flowStatus>1'
          v-show="isDlNavItem === 2 && (format.status !== '' || !format.status)">
          <div class="operationRecordList">
            <div
              class="operationListItem"
              v-for="(item, index) in operationRecordList"
              :key="index"
            >
              <h5 class="operationTitle">{{item.typeName}}</h5>
              <div class="operationTime" v-show='item.optTime'>{{item.optTime | filtTime}}</div>
              <div class="operaterBox">操作人：{{item.optName === 'System' ? '系统' : item.optName}}</div>
              <p class="operationDetail">{{item.memo}}</p>
              <div class="enclosure" v-if="item.attachList">
                <p>附件：</p>
                <div class="enclosureList" v-for="(it,index) in item.attachList" :key="index">
                  <img :src="it" @click="showViewer(index, $event,item.attachList)" alt="" />
                </div>
              </div>
              <span class="timePoint"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import api from '../../../../service/modules/integrity';
    export default {
        data () {
            return {
                format: {}, // 工单信息
                workOrder: [], // 工单评分细则
                heightType: false, // 评分信息列表
                isUpSort: true,
                auditStatus: {},
                // 进度线测试数据
                progressLineList: [
                    { text: '已委托', isOver: true },
                    { text: '已分配', isOver: false },
                    { text: '已签到', isOver: false },
                    { text: '提交审核', isOver: false },
                    { text: '评分完成', isOver: false }
                ],
                dataListNavLists: [],
                // nav栏数据
                dataListNavList: [
                    { name: '评分信息', isShow: true },
                    { name: '工单信息', isShow: true },
                    { name: '操作记录', isShow: true }
                ],
                dataListNavListItem: [
                    { name: '评分信息', isShow: true },
                    { name: '工单信息', isShow: true }
                ],
                isDlNavItem: 0, // tab 下标
                // hasScore: true, // 是否有评分
                currentTime: '', // 品质得分
                // 操作记录按钮测试列表
                operationRecordList: []
            };
        },
        created () {
            this.getWorkOrderDetail();
            this.getWorkOrderScoringDetail();
            this.getWorkOrderLog();
        },
        activated () {
            this.getWorkOrderDetail();
            this.getWorkOrderScoringDetail();
            this.getWorkOrderLog();
        },
        methods: {
            openBottom (item) {
                item.scrollFlag = !item.scrollFlag;
                if (item.scrollFlag == false) {
                    item.detailList1 = [...item.detailList];
                } else if (item.scrollFlag == true) {
                    item.detailList1.length = 3;
                }
            },
            // 评价结果详情
            goScoreResult (e) {
                this.$router.push({
                    path: 'evaluateDescribe',
                    query: {
                        id: e.detailId
                    }
                });
            },

            toPageDetail (item) {
                let parm = {
                    taskId: item.taskId
                };
                api.taskInfo(parm).then(res => {
                    if (res.ret === 0) {
                        this.auditStatus = res.data.auditStatus;
                        if (this.auditStatus == 0) {
                            this.$router.push({
                                path: '/integrity/toAudited',
                                query: {
                                    id: res.data.id,
                                    taskId: res.data.id

                                }
                            });
                        } else if (this.auditStatus == 1) {
                            this.$router.push({
                                path: '/integrity/auditPass',
                                query: {
                                    id: res.data.id,
                                    taskId: res.data.id
                                }
                            });
                        } else if (this.auditStatus == 2) {
                            this.$router.push({
                                path: '/integrity/auditFailed',
                                query: {
                                    id: res.data.id,
                                    taskId: res.data.id
                                }
                            });
                        }
                    }
                });
            },
            // 工单评分细则
            getWorkOrderScoringDetail () {
                api
                    .workOrderScoringDetail({ workOrderId: this.$route.query.enterpriseId })
                    .then(res => {
                        if (res.ret === 0) {
                            res.data.map(item => {
                                item.scrollFlag = true;
                                // item.detailList.length = 2
                                item.detailList1 = [...item.detailList];
                                if (item.detailList.length > 3) {
                                    item.detailList1.length = 3;
                                }
                            });
                            // this.$nextTick(() => {
                            //     console.log(4, this.$refs[0])
                            // })
                            this.workOrder = res.data;
                        }
                    });
            },
            // 工单详情
            getWorkOrderDetail () {
                api
                    .workOrderDetail({ workOrderId: this.$route.query.enterpriseId })
                    .then(res => {
                        if (res.ret === 0) {
                            let data = res.data;
                            this.format = data;
                            this.dataListNavLists = this.dataListNavListItem
                            if (this.format.flowStatus > '1') {
                                this.dataListNavLists = this.dataListNavList
                            }
                            this.currentTime = data.scoreText;
                            if (data.flowStatus === '1') {
                                this.progressLineList[0].isOver = true;
                            } else if (data.flowStatus === '2') {
                                this.progressLineList[0].isOver = true;
                                this.progressLineList[1].isOver = true;
                            } else if (data.flowStatus === '3') {
                                this.progressLineList[0].isOver = true;
                                this.progressLineList[1].isOver = true;
                                this.progressLineList[2].isOver = true;
                            } else if (data.flowStatus === '4') {
                                this.progressLineList[0].isOver = true;
                                this.progressLineList[1].isOver = true;
                                this.progressLineList[2].isOver = true;
                                this.progressLineList[3].isOver = true;
                            } else if (data.flowStatus === '5') {
                                this.progressLineList[0].isOver = true;
                                this.progressLineList[1].isOver = true;
                                this.progressLineList[2].isOver = true;
                                this.progressLineList[3].isOver = true;
                                this.progressLineList[4].isOver = true;
                            }
                        }
                    });
            },
            // 工单操作记录
            getWorkOrderLog () {
                api.workOrderLog({ workOrderId: this.$route.query.enterpriseId }).then(res => {
                    if (res.ret === 0) {
                        let data = res.data
                        let arr = []
                        for (var i = 0; i < data.length; i++) {
                            if (data[i].attachList && data[i].attachList.length) {
                                for (var j = 0; j < data[i].attachList.length; j++) {
                                    arr.push(data[i].attachList[j].url)
                                    if (data[i].optName === 'System') {
                                        data[i].optName = '系统'
                                    }
                                }
                                data[i].attachList = arr
                            }
                        }
                        this.operationRecordList = data
                    }
                })
            },
            // tab 切换
            handleDlNavItemActive (index) {
                this.isDlNavItem = index;
            },
            // 图片预览
            showViewer (index, event, imgList) {
                // this.$ImagePreview({ images: imgList, startPosition: index, closeOnPopstate: true });
                this.$router.push({
                  path: '/complaint/imagesView',
                  query: {
                    imageList:imgList|| [],
                    index
                  },
                })

            }
        },
        // 时间搓
        filters: {
            filtTime (str) {
                var date = new Date(str); // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
                var Y = date.getFullYear() + '-';
                var M =
                    (date.getMonth() + 1 < 10
                        ? '0' + (date.getMonth() + 1)
                        : date.getMonth() + 1) + '-';
                var D =
                    (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
                var h =
                    (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
                var m =
                    (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
                    ':';
                var s =
                    date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
                let strDate = Y + M + D + h + m + s;
                return strDate;
            }
        }
    };
</script>

<style lang="less" scoped>
.workOrderBox {
  padding: 20px 12px;
  background-color: #fbfbfb;
  min-height: 100vh;
  .workOrderContentBox {
    background-color: #fff;
    box-shadow:0px 0px 10px 0px rgba(0,0,0,0.04);
    border-radius:3px;

    .workOrderTop {
      padding: 16px;
      background: #fff;
      border-radius: 3px 3px 0 0;

      .workOrderId {
        font-size: 14px;
        font-weight: bold;
        margin-bottom: 12px;
        color: #333;
      }

      .enterpriseName::after {
        content: "";
        display: block;
        clear: both;
      }

      .enterpriseName {
        margin-bottom: 12px;
        font-size: 14px;
        color: #666666;
        white-space: nowrap;

        > span {
          width: 70px;
          float: left;
           font-size: 14px;
          line-height: 16px;
        }
        > p {
          margin-left: 70px;
          overflow: hidden;
          font-size: 14px;
          line-height: 16px;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }

      .workOrderBages::after {
        content: "";
        display: block;
        clear: both;
      }
      .workOrderBages {
        .locationBage {
          // display: inline-block;
          padding: 4px 4px 0px 4px;
          margin-right: 8px;
          font-size: 10px;
          line-height: 10px;
          color: #2283e6;
          float: left;
        }

        .industryBage {
          // display: inline-block;
          padding: 4px 4px 0px 4px;
          font-size: 10px;
          line-height: 10px;
          color: #36B374;
          float: left;
        }
      }

      .lineBox {
        padding: 16px 16px 0 16px;

        .progressLineBox::after {
          content: "";
          display: block;
          clear: both;
        }

        .progressLineBox {
          min-height: 35px;

          .progressLineBoxItem:not(:last-child) {
            margin-right: 59px;
          }

          .progressLineBoxItem {
            float: left;
            position: relative;

            .progressLinePoint {
              width: 10px;
              height: 10px;
              border-radius: 50%;
              position: relative;

              .progressLineText {
                min-width: 50px;
                text-align: center;
                position: absolute;
                top: 22px;
                left: 50%;
                white-space: nowrap;
                transform: translate(-50%, 0);
              }
            }

            .progressLine {
              width: 60px;
              height: 1.2px;
              position: absolute;
              top: 50%;
              left: -590%;
            }
          }
        }
      }
    }

    .navBox {
      margin-top: 4px;
      margin-bottom: 20px;
      border-radius: 0 0 3px 3px;
    }
    .mainContentBox {
      padding: 11px 16px 15px;

      .dataListNav::after {
        content: "";
        display: block;
        clear: both;
      }

      .dataListNav {
        margin-bottom: 9px;

        .dataListNavItem {
          margin-right: 24px;
          font-size: 14px;
          text-align: center;
          line-height: 28px;
          color: #333;
          border-top: 2px solid transparent;
          border-bottom: 2px solid transparent;
          float: left;
        }

        .dataListNavItem.active {
          color: #36b374;
          border-bottom-color: #36b374;
          font-weight: 500;
        }
      }
    }

    .scoreDetailBox {
      padding: 0 16px 15px;

      .scoreDetailTop {
        margin-bottom: 24px;
        .scoreDetailTop_p {
          font-weight:bold;
          font-size:24px;
          line-height: 24px;
          color: #cccccc;
          text-align: center;
          .unitv{
            font-size:10px;
            font-weight:400;
            color:rgba(54,179,116,1);
          }
        }
        .scoreDetailTop_score {
          font-size: 12px;
          line-height: 16px;
          color: #666666;
          text-align: center;
        }
        .noScore {
          .scoreDetailTop_p{
            font-size: 16px;
            font-weight: bold;
          }
          > h4 {
            margin-bottom: 8px;
            font-size: 16px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            text-align: center;
            color: #ccc;
          }

          > p {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            text-align: center;
            color: #666;
          }
        }

        .hasScore {
          > h4 {
            font-size: 24px;
            font-family: DIN-Bold, DIN;
            font-weight: bold;
            text-align: center;
            color: #36b374;

            > span {
              font-size: 10px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #36b374;
            }
          }
        }
      }

      .scoreDetailListBox {
        .scoreDetailListTitle::after {
          content: "";
          display: block;
          clear: both;
        }

        .scoreDetailListTitle {
          width: 100%;
          border-left: 1px solid #f4f4f4;
          border-right: 1px solid #f4f4f4;
          background-color: #f4f4f4;

          > div:not(:last-child) {
            border-right: 1px solid #f7f7f7;
          }

          > div {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            text-align: center;
            line-height: 36px;
            color: #333;
            float: left;
          }

          .title_type {
            width: 60px;
          }

          .title_scoreTarget {
            width: 194px;
          }

          .title_scoreResult {
            width: 63px;
          }
        }

        // .safeScoreListBox::after{
        //     content: '';
        //     display: block;
        //     clear: both;
        // }

        .safeScoreListBox {
          border: 1px solid #f7f7f7;
          border-top: none;
          position: relative;
          min-height: 50px;
          // >div{
          //     float: left;
          // }

          .safeType {
            width: 60px;
            // height: 143px;
            // padding-top: 50px;
            display: -webkit-flex;
            border-right: 1px solid #f7f7f7;
            position: absolute;
            top: 0;
            bottom: 0;
            align-items: center;
            h4 {
              margin-bottom: 5px;
              font-size: 16px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              text-align: center;
              color: rgba(51, 51, 51, 1);
            }

            p {
              font-size: 10px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              text-align: center;
              color: rgba(153, 153, 153, 1);
            }
            .son {
              vertical-align: middle;
              width: 100%;
            }
          }

          .safeScoreBox {
            // height: 116px;
            margin-left: 60px;
            overflow-y: hidden;

            .safeScoreList {
              width: 257px;
              line-height: auto;

              .safeScoreListItem::after {
                content: "";
                display: block;
                clear: both;
              }

              .safeScoreListItem {
                height: 24px;
                line-height: 24px;

                > div {
                  float: left;
                }

                .scoreTarget {
                  width: 194px;
                  padding: 8px 11px 0 11px;
                  margin-bottom: -20px;
                  border-right: 1px solid #f7f7f7;
                  overflow: hidden;
                  text-align: center;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  color:#333;
                }
                .scoreResult {
                  width: 63px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  .targetNoScore {
                    margin-top:8px;
                    color: #666;
                  }
                  .badness{
                    color: #FF4D4D;
                  }
                  .targetScore {
                    width: 12px;
                    height: 12px;
                    margin-bottom: 2px;
                    margin-top: 10px;
                    display: inline-block;
                    // .img {
                    //   width: 6px;
                    //   height: 6px;
                    //   display: block;
                    // }
                  }
                }
              }
            }
          }

          .savfdataListBtn {
            width: 195px;
            padding: 6px 0 8px 0;
            margin-left: 59px;
            border-left: 1px solid #f7f7f7;
            border-right: 1px solid #f7f7f7;

            > img {
              width: 12px;
              height: 12px;
              display: block;
              margin: 0 auto;
            }
          }
        }
      }
    }

    .workOrderDetaliList {
      padding: 0 16px 8px;

      .workOrderDetaliItem::after {
        content: "";
        display: block;
        clear: both;
      }

      .workOrderDetaliItem {
        margin-bottom: 16px;
        font-size: 14px;
        line-height: 16px;
        font-weight: 400;

        .workOrderDetaliTitle {
        //   width: 96px;
          color: #999999;
          float: left;
          margin-right: 12px;
        }

        .workOrderDetaliContent {
          float: left;
          position: absolute;
          left: 130px;
          max-width: 200px;
          overflow: hidden; //超出的文本隐藏
          text-overflow: ellipsis; //溢出用省略号显示
          white-space: nowrap; //溢出不换行
          color: #333;
        }
      }
    }

    .operationRecordListBox {
      padding: 0 16px;

      .operationRecordList {
        .operationListItem:first-child {
          color: #333;

          .timePoint {
            border-color: #36b374;
          }
        }

        .operationListItem:last-child {
          border-left: none;
        }

        .operationListItem {
          padding: 0 15px 30px 18px;
          color: #999;
          border-left: 1px solid #eaeaea;
          position: relative;

          .operationTitle {
            margin-bottom: 12px;
            font-size: 14px;
            font-weight: bold;
          }

          .operationTime {
            margin-bottom: 8px;
            font-size: 12px;
          }

          .operaterBox {
            margin-bottom: 6px;
            font-size: 12px;
          }

          .operationDetail {
            margin-bottom: 6px;
            font-size: 12px;
            line-height: 16px;
          }

          .enclosure {
            > p {
              margin-bottom: 6px;
            }

            .enclosureList {
              width: 74px;
              height: 74px;
              margin: 0 8px 8px 0;
              border-radius: 3px;
              display: inline-block;

              > img {
                width: 74px;
                height: 74px;
                border-radius: 3px;
              }
            }
          }

          .timePoint {
            width: 13px;
            height: 13px;
            background-color: #fff;
            border: 1px solid #eaeaea;
            border-radius: 50%;
            position: absolute;
            top: -2px;
            left: -8px;
          }
        }
      }
    }
  }
}
</style>
